export const tableStyles = {
  table: {
    style: {
      //   border: '1px solid #e2e8f0', // light gray outline
      borderRadius: '0.4rem',
      overflow: 'hidden', // ensures radius applies to child elements
      backgroundColor: '#f8fafc', // light gray background for body
    },
  },
  headCells: {
    style: {
      backgroundColor: '#1B8F9B', // Primary color
      color: '#ffffff',
      fontSize: '14px',
      letterSpacing: '0.5px',
    },
  },
  rows: {
    style: {
      backgroundColor: '#f8fafc', // match body bg
      borderBottom: '1px solid #e2e8f0',
      '&:hover': {
        backgroundColor: '#E8F5F6', // subtle brand tint on hover
      },
    },
  },
  pagination: {
    style: {
      backgroundColor: '#f8fafc', // same light gray as body
      borderTop: '1px solid #e2e8f0',
      padding: '16px 20px',
      fontSize: '14px',
      color: '#475569',
      borderBottomLeftRadius: '0.4rem',
      borderBottomRightRadius: '0.4rem',
    },
    pageButtonsStyle: {
      borderRadius: '6px',
      height: '36px',
      width: '36px',
      padding: '0',
      margin: '0 2px',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      backgroundColor: 'transparent',
      border: '1px solid #e2e8f0',
      color: '#475569',
      '&:hover': {
        backgroundColor: '#E8F5F6',
        borderColor: '#1B8F9B',
        color: '#1B8F9B',
      },
      '&:focus': {
        outline: '2px solid #1B8F9B',
        outlineOffset: '2px',
      },
      '&[aria-current="page"]': {
        backgroundColor: '#1B8F9B',
        borderColor: '#1B8F9B',
        color: '#ffffff',
      },
    },
  },
};
